module.exports = __webpack_public_path__ + "img/_54A6775_t.6caed70c.jpg";